import { Page } from "@/models/page-models/Page";

export const CreatePaymentCollectionReceipt: Page = {
  "path": "create-payment-collection-receipt",
  "name": "Create Payment Receipt",
  "props": {
    "data": {
      "title": "Create Payment Receipt",
      "printable": "FALSE",
      "url": "create-payment-collection-receipt",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.customer",
                  "label": "Select Customer",
                  "onChange": [
                    {
                      "executionOrder": 1,
                      "name": "copyCustomerContacts"
                    }
                  ],
                  "disabled": "FALSE",
                  "items": "fetchedData.customers.data",
                  "itemText": "name",
                  "itemValue": "_id",
                  "formula": "fn(HELPER_FN,customerAlias,{{__item}})"
                },
                {
                  "type": "dropdown",
                  "variable": "fetchedData.selectedContact",
                  "label": "Select Contact",
                  "onChange": [
                    {
                      "executionOrder": 1,
                      "name": "copyContactDetails"
                    }
                  ],
                  "disabled": "FALSE",
                  "items": "fetchedData.contact",
                  "itemText": "firstName",
                  "itemValue": "firstName",
                  "formula": "fn(HELPER_FN,contactName,{{__item}})"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.customerPaymentMode",
                  "label": "Select Payment Mode",
                  "disabled": "FALSE",
                  "items": "[\"Check\",\"Cash\",\"Transfer\"]",
                  "dropdownType": "static"
                },
                {
                  "type": "input",
                  "variable": "formData.voucherNo",
                  "label": "Foxpro Voucher No",
                  "disabled": "FALSE"
                }
              ]
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.bankName",
                  "label": "Select Bank",
                  "disabled": "FALSE",
                  "items": "[{\"text\":\"Arab National Bank: SA69 3040 0108 0953 4466 0011\",\"value\":\"ANB\"},{\"text\":\"Saudi National Bank: SA58 1000 0065 9123 8300 0110\",\"value\":\"SNB\"},{\"text\":\"Banque Saudi Fransi: SA56 5500 0000 0909 8470 0491\",\"value\":\"BSF\"}]",
                  "itemText": "text",
                  "itemValue": "value",
                  "dropdownType": "static"
                },
                {
                  "type": "input",
                  "variable": "formData.bankTransactionNumber",
                  "label": "Bank Transaction No",
                  "disabled": "FALSE"
                }
              ]
            },
            {
              "name": "4",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.expectedAmountReceived",
                  "label": "Received Amount",
                  "unit": "SAR",
                  "disabled": "FALSE"
                },
                {
                  "type": "fileupload",
                  "variable": "formData.uploadedProof",
                  "label": "Payment Proof",
                  "disabled": "FALSE",
                  "color": "secondary",
                  "previewType": "no-preview"
                }
              ]
            },
            {
              "name": "5",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Create Receipt",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "name": "submitReceipt"
                    }
                  ],
                  "disabled": "FALSE",
                  "color": "primary"
                }
              ]
            }
          ],
          "type": "genericGroup"
        }
      ]
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getCustomers",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/customers?showDisabled=true",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.customers"
        },
        "name": "getCustomers",
        "executeIf": "fn(MATCH_ROLE,Sales | Manager)"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getMyCustomers",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/my-customers?showDisabled=true",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.customers"
        },
        "name": "getMyCustomers",
        "executeIf": "fn(MATCH_ROLE,Sales | Account Executive)"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getAllCustomers",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/customers?showMisc=true&showDisabled=true",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.customers"
        },
        "name": "getAllCustomers",
        "executeIf": "fn(LOGICAL,fn(MATCH_ROLE,Accounting | Executive),||,fn(MATCH_ROLE,Accounting | Manager))"
      },
      {
        "executionOrder": 1,
        "name": "copyDefaultPaymentsArray"
      }
    ],
    "functions": [
      {
        "name": "submitReceipt",
        "type": "fnSubmit",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/invoice/payment-receipt",
        "arg2Key": "postData",
        "arg2Value": "formData",
        "arg3Key": "fnsAfterSubmit",
        "arg3Value": "openPaymentsPage"
      },
      {
        "name": "copyCustomerContacts",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "__selectedObject.contactDetails",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.contact"
      },
      {
        "name": "copyDefaultPaymentsArray",
        "type": "fnCopyData",
        "arg1Key": "sourceFn",
        "arg1Value": "getDefaultPaymentsArray",
        "arg2Key": "destinationKey",
        "arg2Value": "formData",
        "arg3Key": "destinationKeyType",
        "arg3Value": "Object",
        "arg4Key": "append",
        "arg4Value": "TRUE"
      },
      {
        "name": "getDefaultPaymentsArray",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "payments": []
        },
        "staticObject": true
      },
      {
        "name": "copyContactDetails",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "__selectedObject",
        "arg2Key": "destinationKey",
        "arg2Value": "formData.contact"
      },
      {
        "name": "openPaymentsPage",
        "type": "fnRedirect",
        "arg1Key": "redirectUrl",
        "arg1Value": "fn(CONDITIONAL,fn(LOGICAL,fn(MATCH_ROLE,Accounting | Manager),||,fn(MATCH_ROLE,Accounting | Executive)),/accounts-dashboard?tab=1,/sales-payments?tab=1)"
      }
    ]
  },
  "forRole": "ACCOUNTING_MANAGER,ACCOUNTING_EXECUTIVE,SALES_ACCOUNT_EXECUTIVE,SALES_MANAGER",
  "visible": false,
  "routerPriority": 72
}